import './InfoBanner.scss';

import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

type Variant = 'info' | 'warning';

type Props = {
  children: React.ReactNode;
  className?: string;
  variant?: Variant;
};

export default function InfoBanner ({ children, className, variant = 'info' }: Props) {
  const Icon = variant === 'warning' ? WarningAmberIcon : InfoOutlinedIcon;
  return (
    <div className={`info-banner info-banner--${variant}${className ? ` ${className}` : ''}`} role='note'>
      <Icon className='info-banner__icon' />
      <span>{children}</span>
    </div>
  );
}
